import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=1c935aea"
import script from "./InputForm.vue?vue&type=script&lang=ts"
export * from "./InputForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c935aea')) {
      api.createRecord('1c935aea', component.options)
    } else {
      api.reload('1c935aea', component.options)
    }
    module.hot.accept("./InputForm.vue?vue&type=template&id=1c935aea", function () {
      api.rerender('1c935aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/InputForm/InputForm.vue"
export default component.exports